import { connect } from 'react-redux';

import { selectors as catalogSelectors } from 'dux/catalog';
import { selectors as userSelectors } from 'dux/user';
import { actionCreators, selectors as createInstanceSelectors } from 'dux/createInstance';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import { selectors as orgSelectors } from 'dux/org';
import CreateInstancePage from './CreateInstancePage';

function mapStateToProps(state) {
  const catalog = catalogSelectors.getCatalogState(state);
  const needsBilling = orgSelectors.needsBilling(state);
  const { supportLevelName } = orgSelectors.getOrgState(state);
  const isBillingUser = userSelectors.isBillingUser(state);
  const userRoles = userSelectors.getIdentityState(state).roles;
  const user = userSelectors.getIdentityState(state);
  return {
    ...createInstanceSelectors.getCreateInstanceState(state),
    catalog,
    needsBilling,
    supportLevelName,
    isBillingUser,
    userRoles,
    user,
  };
}

const mapDispatchToProps = {
  goToNextStage: actionCreators.goToNextStage,
  goToPreviousStage: actionCreators.goToPreviousStage,
  resetSteps: actionCreators.resetSteps,
  selectService: actionCreators.selectService,
  selectServiceSubtype: actionCreators.selectServiceSubtype,
  selectVersion: actionCreators.selectVersion,
  selectRegion: actionCreators.selectRegion,
  enterName: actionCreators.enterName,
  selectProvider: actionCreators.selectProvider,
  selectFlavor: actionCreators.selectFlavor,
  selectPlan: actionCreators.selectPlan,
  enterCidr: actionCreators.enterCidr,
  getIp: actionCreators.getIp,
  getIpClear: actionCreators.getIpClear,
  enterAclName: actionCreators.enterAclName,
  selectAclKind: actionCreators.selectAclKind,
  addAcl: actionCreators.addAcl,
  removeAcl: actionCreators.removeAcl,
  checkAddIpsLater: actionCreators.checkAddIpsLater,
  createInstance: actionCreators.createInstance,
  getPrice: actionCreators.getPrice,
  getPriceDebounced: actionCreators.getPriceDebounced,
  trackButtonClick: clickTrackerActionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateInstancePage);
